import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-user-ticket',
  templateUrl: './user-ticket.component.html',
  styleUrls: ['./user-ticket.component.css']
})
export class UserTicketComponent implements OnInit {

//   usersList: any= []
//   status = ""
//   userId = ""
//   filteredData: any= []

//   constructor(private toastr: ToastrService,private generic_service: GenericService) { }

//   endDate:any;
//   startDate:any;
  
//   pageNumber1: number = 0;
//   pageNumber: number = 0;
//   totalRecords: number = 0;
//   recordsPerPage:number = 10;
//   tableSize: number = 10;
  
//   ngOnInit(): void {
//     this.endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
//     this.startDate = new Date()
//     this.startDate.setDate(this.startDate.getDate()-7);
//     this.startDate = formatDate(this.startDate, 'yyyy-MM-dd', 'en-US')
//     this.getUsers()
//   }
//   getUsers(){
//     this.generic_service.getUsers().subscribe(
//       (res:any)=>{
//         this.usersList = res.response;
//       }
//     )
//   }

//   getFilteredData(pageNumber:any,recordsPerPage:any){
//     let startDate = new Date(this.startDate).getTime()
//     let endDate = new Date(this.endDate).getTime()
//     this.generic_service.ticketFilterByAndUserIdAndDates(this.userId,startDate,endDate,pageNumber,recordsPerPage).subscribe(
//       (response:any)=>{
//         console.log(response)
//         this.filteredData = []
//         this.filteredData = response.response.ticketList
//         this.totalRecords = response.response.totalRecords

//       },
//       (error:any)=>{
//         console.log(error)
//       }
//     )
//   }
// }


i: any;
deleteId: any;
ticketcontroller:any = [];
TicketTask: any = [];
users: any = [];
TicketTaskdata: any = [];
TicketData: any = [];
tagUsersdropdownList  = [];
tagUsersselectedItems:any = [];
tagUsersdropdownSettings:IDropdownSettings = {
  singleSelection: false,
  idField: 'userId',
  textField: 'userName',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  itemsShowLimit: 3,
  allowSearchFilter: true
};
userIdList = [];
taskMasters:any = []
status= "OPEN"
addTaskButton = true
ctid:any = ""


pageNumber1: number = 0;
pageNumber: number = 0;
totalRecords: number = 0;
recordsPerPage:number = 10;
tableSize: number = 10;

constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,private router: Router) { }

form: any | FormGroup
Taskform:any | FormGroup
modelSubtitle = false
IDs:any = []
data:any = []
fileType:any;
file = '';
images:any= [];
videos:any= [];
audios:any= [];
description = "";
typeId = "";
heading = "";
details = "";
source = "";
customerID = "";
customerType = ""
searchFilter = ''
newTicketCount= 0
ticketId = 0
ticketDesc = ""
taskId = ""
note = ""
ticketStatus = ""
ticketClosingOtp = ""
usersList: any= []
assignInput = ""
addClassType = ""
TaskNameAndDescription: any = []
cid:any
usersWithoutCustomers:any = []
searchTicketId: any = ""
ngOnInit(): void {
  this.cid = sessionStorage.getItem('cid')
  this.getUsers();
  this.getUsersWithoutCustomers()
  this.getAllTaskNameAndDescription()
  this.generic_service.gettypeids().subscribe((res: any) => {
    console.log(res)
    this.IDs = res.response
  })
  
  // this.getTicketcontroller()

  this.form = this.fb.group({
    description: [''],
    typeId: [''],
    heading:[''],
    details:[''],
    customerID:[''],
    customerType:['']
  });

  this.Taskform = this.fb.group({
    name: [''],
    description: [''],
    assignedTo: [''],
    tagUserIds: [''],
    taskExpStartDate: [''],
    taskExpEndDate: [''],
  });

}

getUsersWithoutCustomers(){
  this.generic_service.getUsersWithoutCustomers().subscribe(
    (res:any)=>{
      console.log(res);
      this.usersWithoutCustomers = res.response;
    }
  )
}

onTableDataChange(event: any) {

  this.pageNumber = event-1;
  this.pageNumber1 = event;
  this.getTicketcontroller();

}


onItemSelect(item: any) {
  console.log(item);
}
onSelectAll(items: any) {
  console.log(items);
}

addcontroller(){

  let body = {
    "version": 0,
    "isActive": true,
    "description": "",
    "typeId":String(this.form.get('typeId').value),
    "ticketSubTypeId": 0,
    "parentTicketId": 0,
    "priorityId": 0,
    "ticketStatus": [
      {
        "note": "",
        "ticketStatus": "OPEN",
        "updatedDate": 0
      }
    ],
    "heading": String(this.form.get('heading').value),
    "details":  String(this.form.get('details').value),
    "resolution": "",
    "source":  "Admin",
    "raisedBy": "",
    "remarks": "",
    "assignedTo": "",
    "startTime": 0,
    "endTime": 0,
    "customerID":  String(this.form.get('customerID').value),
    "customerName": "",
    "customerNotes": "",
    "technicianNotes": "",
    "startNotes": "",
    "endNotes": "",
    "pendingNotes": "",
    "customerType":  String(this.form.get('customerType').value),
    "latestTicketStatus": "OPEN",
    "assignedBy": "",
    "latitude": "",
    "startLatitude": "",
    "startLongitude": "",
    "endLatitude": "",
    "endLongitude": "",
    "agentId": 0,
    "audio": [],
    "video": [],
    "image": [],
    "tagUserIds": [],
    "assignedOn": 0,
    "longitude": "",
    "ticketNo": 0,
    "cid": this.cid
  }


  console.log(body)
  this.generic_service.addcontroller(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getTicketcontroller()
      this.toastr.success(response.message);
      this.cancelModel()
      this.form.clear()
    },(err:any)=>{
      console.log(err)
      this.toastr.error(err.errors[0].description);

    }
  )
}

Ticketid(id:any,details:any,name:any){
  this.ticketId = id
  this.Taskform.get('description').setValue(details);
  this.Taskform.get('name').setValue(name);
  console.log(this.ticketId)
}

addTicketTask(){
  this.addTaskButton = false
  let tagUserIds = [];
  for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
    tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
  }

  let body = {
    "ticketId": this.ticketId,
    "taskList": [
      {
        "version": 0,
        "isActive": true,
        "description":String(this.Taskform.get('description').value),
        "taskRegType": "",
        "taskRegId": "",
        "taskSINumber": 0,
        "taskListingNumber": 0,
        "assignedTo": String(this.Taskform.get('assignedTo').value),
        "taskExpStartDate": new Date(this.Taskform.get('taskExpStartDate').value).getTime(),
        "taskExpEndDate": new Date(this.Taskform.get('taskExpEndDate').value).getTime(),
        "taskActStartDate": 0,
        "taskActEndDate": 0,
        "taskExpDuration": 0,
        "taskActDuration": 0,
        "status": [
          {
            "note": "",
            "taskStatus": "NEW",
            "updatedDate": 0
          }
        ],
        "completedPercentage": 0,
        "notes": "",
        "audio": this.audios,
        "video": this.videos,
        "image": this.images,
        "tagUserIds": tagUserIds,
        "name": String(this.Taskform.get('name').value),
        "cid": this.cid
      }
    ]
  }
  console.log(body)
  this.generic_service.addTicketTask(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllTicketTask()
      this.toastr.success(response.message);
      this.cancelModel()
      this.clearForm()
      this.addTaskButton = true
    },(err:any)=>{
      console.log(err)
      this.toastr.error(err.errors[0].description);
      this.addTaskButton = true
    }
  )


}

getAllTicketTask(){
  this.generic_service.getAllTicketTask().subscribe(
    (response:any)=>{
      this. TicketTask= response.taskList;
      console.log(response)
    }
  )
}

getTicketSearchById(){
  // this.getTicketTaskByID(this.searchTicketId)
}

getTicketTaskByID(id:any){
  console.log(id)
  this.ticketId = id
  this.getSingleTicket(id)
  this.getAllTaskMasters()
  // this.TicketData = []
  this.generic_service.getTicketTaskByID(id).subscribe(
    (res:any)=>{
      // this.TicketData.push(res.response.ticket);
      this.TicketTaskdata = res.response.taskList;
      console.log(res);
      let arr:any = [];
      arr.push(Number(sessionStorage.getItem('userId')))
      let arr1:any = [];
      // arr = res.response.taskList.tagUserIds;
      for (let i=0; i<res.response.taskList.length; i++){
        if(res.response.taskList[i].assignedTo != null && res.response.taskList[i].assignedTo != 0){
          arr1.push(res.response.taskList[i].assignedTo)
        }
        if(res.response.taskList[i].tagUsers.length != 0){
          for(let j=0; j<res.response.taskList[i].tagUsers.length; j++){
            arr.push(res.response.taskList[i].tagUsers[j].userid)
          }
        }
      }
      let arr3 = arr.concat(arr1)
      this.userIdList = arr3
      // arr.push(res.response.assignedTo)
      this.userIdList = this.userIdList.filter((item,index) => this.userIdList.indexOf(item) === index);
      console.log(this.userIdList)

    },
    (err:any)=>{
      console.log(err)
      this.TicketTaskdata = []
    }
  )
}

getUsers(){
  this.generic_service.getUsers().subscribe(
    (res:any)=>{
      this.users = res.response;
      this.usersList = res.response;
      this.tagUsersdropdownList = res.response
      console.log(res);
    }
  )
}


cancelModel(){
  document.getElementById("closeModalButton")?.click()
  document.getElementById("closeModalButton1")?.click()
  document.getElementById("closeModalButton2")?.click()
  document.getElementById("closeModalButton3")?.click()
  document.getElementById("closeModalButton67")?.click()
  document.getElementById("closeModalButton12")?.click()
}

getTicketcontroller(){
  this.ticketByStatus()
}

editskill(){

  this.data[this.i].description=this.description
  this.data[this.i].typeId=this.typeId
  this.data[this.i].heading=this.heading
  this.data[this.i].details=this.details
  this.data[this.i].source=this.source
  this.data[this.i].customerID=this.customerID
  this.data[this.i].customerType=this.customerType
  this.close()
}
open() {
  this.modelSubtitle = true;
}
close() {
  this.modelSubtitle = false;
  this.description = ""
  this.typeId = ""
  this.heading = ""
  this.details = " "
  this.source = ""
  this.customerID = ""
  this.customerType =""     
}

edit(i:any){
  this.open();
  this.description = this.data[i].description;
  this.typeId = this.data[i].typeId ;
  this.heading = this.data[i].heading ;
  this.details = this.data[i].details ;
  this.source = this.data[i].source ;
  this.customerID = this.data[i].customerID ;
  this.customerType = this.data[i].customerType ;
}

delTicketController(){
  this.generic_service.delTicketcontroller(this.deleteId).subscribe(
    (res:any)=>{
      console.log(res);
      this.toastr.success(res.message);
      this.getTicketcontroller()
      this.cancelModel();
    },err=>{
      console.log(err)
      this.toastr.error(err.errors[0].description)
    }
  )
}

del(id:any){
  this.deleteId = id
}

getSingleTicket(id:any){
  console.log(id)
  this.TicketData = []
  this.generic_service.getSingleTicket(id).subscribe(
    (res:any)=>{
      this.TicketData = [];
      this.TicketData.push(res.response.ticket);
      console.log(res)
    }
  )
}

onSelectFile(event:any){
  if(event.target.files){
    console.log(event.target.files[0].type)
    console.log(event.target.files[0])
    if(event.target.files[0].type == "image/jpeg" || event.target.files[0].type == "image/png" || event.target.files[0].type == "image/png"){
      console.log('image')
      this.fileType = 'image'
    }else if(event.target.files[0].type == "video/mp4"){
      console.log('video')
      this.fileType = 'video'
    }else if(event.target.files[0].type == "audio/mpeg"){
      console.log('audio')
      this.fileType = 'audio'
    }
    var reader = new FileReader;
    reader.readAsDataURL(event.target.files[0]);
    reader.onload=(e:any)=>{
      this.file=e.target.result;
      if(this.fileType == 'image'){
        this.images.push(this.file)
      }
      if(this.fileType == 'video'){
        this.videos.push(this.file)
      }
      if(this.fileType == 'audio'){
        let file = URL.createObjectURL(event.target.files[0])
        this.audios.push(file)
      }
    }
  }
}

addImageBtn(){
  document.getElementById("add-image-btn")?.click()
}

addVideoBtn(){
  document.getElementById("add-video-btn")?.click()
}

addAudioBtn(){
  document.getElementById("add-audio-btn")?.click()
}
 
addc(i: any){
  console.log(i)
  let list = document.getElementById(i)
  if(list?.classList.contains('dropdown-data')){
    list.classList.remove('dropdown-data')
  }else{
    list?.classList.remove('dropdown-data-show')
    list?.classList.add('dropdown-data')
  }
}

activeStatus(id: string){

}

insertConversation(){
  let body =  {
    "version": 0,
    "isActive": true,
    "description": "string",
    "id": 0,
    "conversationType": "TICKET",
    "ticketTaskId": Number(this.ticketId),
    "userIdList": this.userIdList,
    "remarks": "string",
    "cid": this.cid
  }
  console.log(body)
  this.generic_service.insertConversation(body).subscribe(
    (response:any)=> {
      console.log(response)
      this.toastr.success(response.message)
      this.cancelModel();
      this.router.navigateByUrl('/admin/create-user')
    },
    (err:any)=> {
      console.log(err)
      this.cancelModel();
      this.toastr.error(err.error.errors[0].description)
      this.router.navigateByUrl('/admin/create-user')

    }
  )
}

remoates(){
  var array = this.userIdList;
  return array.filter((item,index) => array.indexOf(item) === index);
}

clearForm(){
  this.tagUsersselectedItems = []
  this.images = [];
  this.videos = [];
  this.audios = [];
  this.form.reset()
}

statusDropdown(){
  let list = document.getElementById('dropS')
  if(list?.classList.contains('status-dropdown-show')){
    list.classList.remove('status-dropdown-show');
  }else{
    list?.classList.add('status-dropdown-show')
  }
}

reopenTicket(ticketId:any){
  let body = {
    "note": "Re-opened the ticket",
    "ticketStatus": "OPEN",
    "updatedDate": 0
  }
  this.generic_service.updateTicketStatus(ticketId,body).subscribe(
    (response:any)=>{
      this.toastr.success(response.message)
      this.getSingleTicket(ticketId)
      this.statusDropdown()
      this.getTicketcontroller()
      console.log(response)
    },
    (error:any)=>{
      console.log(error)
      this.toastr.error(error.error.errors[0].description)
    }
  )
}

updateTicketStatus(ticketId:any){
  let body = {
    "note": String(this.note),
    "ticketStatus": String(this.ticketStatus),
    "updatedDate": 0,
    "images": [],
    "audios": [],
    "videos": [],
    "ticketClosingOtp": this.ticketClosingOtp
  }
  this.generic_service.updateTicketStatus(ticketId,body).subscribe(
    (response:any)=>{
      this.toastr.success(response.message)
      this.getSingleTicket(ticketId)
      this.statusDropdown()
      this.getTicketcontroller()
      console.log(response)
      this.ticketClosingOtp = ""
      this.ticketStatus = ""
      this.note = ""
    },
    (error:any)=>{
      console.log(error)
      this.toastr.error(error.error.errors[0].description)
    }
  )
}


AssignToUser(ticketId:any, userId: any,ticketStatus:any,name:string){
  let note = "";
  if(ticketStatus == "REASSIGNED"){
    note = "Ticket REASSIGNED to " + name;
  }
  if(ticketStatus == "ASSIGNED"){
    note = "Ticket ASSIGNED to " + name;
  }
  let body = {
    "ticketId": Number(ticketId),
    "userId": Number(userId),
    "ticketStatusDTO": {
      "note": String(note),
      "ticketStatus": "OPEN",
      "updatedDate": 0
    }
  }
  console.log(body)
  this.generic_service.ticketAssignToUser(body).subscribe(
    (response:any)=>{
      console.log(response);
      this.getSingleTicket(ticketId)
      this.addClass('assignedTo')
    },
    (error:any)=>{
      console.log(error)
    }
  )
}

addClass(value:any){
  console.log(value)
  if(this.addClassType == ''){
    let list = document.getElementById('assign-and-tag-data')
    if(list?.classList.contains('assign-show')){
      list.classList.remove('assign-show')
      this.addClassType = ''
    }else{
      list?.classList.add('assign-show')
      this.addClassType = value
    }
  }else{
    if(this.addClassType == value){
      let list = document.getElementById('assign-and-tag-data')
      if(list?.classList.contains('assign-show')){
        list.classList.remove('assign-show')
        this.addClassType = ''
      }else{
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    }else{
      this.addClassType = value
    }
  }
}

getAllTaskMasters(){
  this.generic_service.getAllTaskMaster().subscribe(
    (response:any)=>{
      console.log(response)
      this.taskMasters = response.response
    }
  )
}

getAllTaskNameAndDescription(){
  this.generic_service.getAllTaskNameAndDescription().subscribe(
    (response:any)=>{
      console.log(response)
      this.TaskNameAndDescription = response.response
    }
  )
}

addTaskMaster(j:any){
  let tasks = this.taskMasters[j].taskGroup;
  console.log(tasks)
  for(let i = 0; i < tasks.length; i++) {
    this.addMasterTicketTask(tasks[i].name,tasks[i].description)
  }

  setTimeout(() => this.reload(), 2000);

}

reload(){
  this.getTicketTaskByID(this.ticketId)
  document.getElementById("closeModalButton5")?.click()
}


addMasterTicketTask(name:any,description: any){

  let tagUserIds = [];
  for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
    tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
  }

  let body = {
    "ticketId": this.ticketId,
    "taskList": [
      {
        "version": 0,
        "isActive": true,
        "description":String(description),
        "taskRegType": "",
        "taskRegId": "",
        "taskSINumber": 0,
        "taskListingNumber": 0,
        "assignedTo": String(this.Taskform.get('assignedTo').value),
        "taskExpStartDate": new Date(this.Taskform.get('taskExpStartDate').value).getTime(),
        "taskExpEndDate": new Date(this.Taskform.get('taskExpEndDate').value).getTime(),
        "taskActStartDate": 0,
        "taskActEndDate": 0,
        "taskExpDuration": 0,
        "taskActDuration": 0,
        "status": [
          {
            "note": "",
            "taskStatus": "NEW",
            "updatedDate": 0
          }
        ],
        "completedPercentage": 0,
        "notes": "",
        "audio": this.audios,
        "video": this.videos,
        "image": this.images,
        "tagUserIds": tagUserIds,
        "name": String(name),
        "cid": this.cid
      }
    ]
  }
  console.log(body)
  this.generic_service.addTicketTask(body).subscribe(
    (response:any)=>{
      console.log(response)
      // this.getAllTicketTask()
      // this.toastr.success(response.message);
      // this.cancelModel()
      // this.clearForm()
    },(err:any)=>{
      console.log(err)
      this.toastr.error(err.errors[0].description);

    }
  )
}

ticketStatusDropdown(){
  console.log(this.ticketStatus)
  if(this.ticketStatus == "COMPLETED"){
    this.note = "Ticket Completed by" + " " + sessionStorage.getItem('userName')
  }
  if(this.ticketStatus == "CLOSED"){
    this.note = "Ticket Closed by"  + " " + sessionStorage.getItem('userName')
  }

}

autoFill(taskName: any,taskDescription:any){
  this.Taskform.get('name').setValue(taskName);
  this.Taskform.get('description').setValue(taskDescription);
  document.getElementById("closeModalButton67")?.click()

}

ticketStatusDropdownChange(){
  this.pageNumber = 0

  if(this.status == "UNASSIGNED"){
    this.getAllUnAssignedTicketTaskList(this.pageNumber,this.recordsPerPage)
  }else{
    if(this.status != "ALL"){
      this.ticketFilterByStatus(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllTicketTaskWithPagination(this.pageNumber,this.recordsPerPage)
    }    
  }
}


// ticketByStatus(){
//   this.pageNumber = 0
//   if(this.status != "ALL"){
//     this.ticketFilterByStatus(this.pageNumber,this.recordsPerPage)
//   }else{
//     this.getAllTicket(this.pageNumber,this.recordsPerPage)
//   }
// }
ticketByStatus(){
  if(this.status == "UNASSIGNED"){
    this.getAllUnAssignedTicketTaskList(this.pageNumber,this.recordsPerPage)
  }else{
    if(this.status != "ALL"){
      this.ticketFilterByStatus(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllTicket(this.pageNumber,this.recordsPerPage)
    }    
  }
}

ticketFilterByStatus(pageNumber:any,recordsPerPage:any){
  this.generic_service.ticketFilterByStatus(pageNumber,recordsPerPage,this.status).subscribe(
    (response:any)=>{
      console.log(response)
      this.totalRecords = response.response.totalRecords
      this.data = response.response.ticketTaskResponseList
    },
    (error:any)=>{
      console.log(error)
    }
  )
}

getAllTicket(pageNumber:any,recordsPerPage:any){
  this.generic_service.getcontroller(pageNumber,recordsPerPage).subscribe(
    (response:any)=>{
      this.totalRecords = response.response.totalRecords
      this.data = response.response.ticketList
      let count = 0
      // for(var i=0; i<response.response.length; i++) {
      //   if(response.response[i].ticketStatus == 'NEW'){
      //     count++;
      //     console.log(response.response[i].ticketStatus)
      //   }
      // }
      // this.newTicketCount = count
      console.log(response)
    }
  )
}

// getAllUnAssignedTicketTaskList(){
//   this.generic_service.getAllUnAssignedTicketTaskList().subscribe(
//     (response:any)=>{
//       this.totalRecords = response.response.totalRecords
//       this.data = response.response.ticketList
//       console.log(response)
//     }
//   )
// }

taskPopUpClose(){
  document.getElementById("closeModalButton3")?.click()
}

assignTaskId: any = ""
userId: any = ""
taskStatus: any = ""
assignName: any = ""

taskSelected(taskId:any,taskStatus:any) {
  this.assignTaskId = taskId;
  this.taskStatus = taskStatus;
}

getAllUnAssignedTicketTaskList(pageNumber:any,recordsPerPage:any){
  this.generic_service.getAllUnAssignedTicketTaskList(pageNumber,recordsPerPage).subscribe(
    (response:any)=>{
      console.log(response)
      this.totalRecords = response.response.totalRecords
      this.data = response.response.ticketTaskResponseList
    }
  )
}

getAllTicketTaskWithPagination(pageNumber:any,recordsPerPage:any)
{
  this.generic_service.getAllTicketTaskWithPagination(pageNumber,recordsPerPage).subscribe(
    (response:any)=>{
      console.log(response)
      this.totalRecords = response.response.totalRecords
      this.data = response.response.ticketTaskResponseList
    }
  )
}


taskAssignToUser(){
  if(this.userId == ""){
    return;
  }

  for(var i = 0; i < this.usersWithoutCustomers.length; i++) {
    if(this.usersWithoutCustomers[i].userId == Number(this.userId)){
      this.assignName = this.usersWithoutCustomers[i].userName
    }
  }
  let note = "";
  if(this.taskStatus == "REASSIGNED"){
    note = "Task REASSIGNED to " + this.assignName;
  }else{
    note = "Task ASSIGNED to " + this.assignName;
  }
  let body = {
    "taskId": Number(this.assignTaskId),
    "userId": Number(this.userId),
    "taskStatusDTO": {
      "note": String(note),
      "taskStatus": String(this.taskStatus),
      "updatedDate": 0
    }
  }
  console.log(body)
  this.generic_service.taskAssignToUser(body).subscribe(
    (response:any)=>{
      console.log(response);
      this.getTicketTaskByID(this.ticketId)
      document.getElementById("closeTaskAssign")?.click()

      // this.getSingleTask(taskId);
    },
    (error:any)=>{
      console.log(error)
    }
  )
}

  ticketById(){
    this.TicketData = []
    this.generic_service.getTicketTaskByID(this.searchTicketId).subscribe(
      (res:any)=>{
        let ticket = []
        ticket.push(res.response.ticket);
        console.log(res)
        this.data = []
        this.data.push(res.response)

      }
    )

  }
}